/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Necessary_DescriptionInputs */

const en_cookies_necessary_description = /** @type {(inputs: Cookies_Necessary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions, sign-in, and security. The app doesn't work without these, so they can't be switched off.`)
};

const pl_cookies_necessary_description = /** @type {(inputs: Cookies_Necessary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesje, logowanie i bezpieczeństwo. Bez nich aplikacja nie działa, więc nie da się ich wyłączyć.`)
};

/**
* | output |
* | --- |
* | "Sessions, sign-in, and security. The app doesn't work without these, so they can't be switched off." |
*
* @param {Cookies_Necessary_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_necessary_description = /** @type {((inputs?: Cookies_Necessary_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Necessary_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_necessary_description(inputs)
	return en_cookies_necessary_description(inputs)
});